module.exports = __webpack_public_path__ + "img/tablea.70e1a179.svg";